import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/vercel/path1/node_modules/@babel/runtime/regenerator/index.js";
import { get } from "lodash";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { Suspense, useMemo } from "react";
import Loader from "../../components/Loader";
import constants from "../../utils/constants";
import classNames from "classnames";
import { isWebView } from "../../utils";
import { t } from "i18next";
var getComponent = function getComponent(currentPageName) {
  var _component = null;
  switch (currentPageName) {
    case constants.SETTINGS.NOTIFICATIONS:
      _component = import("../../components/NotificationSettings");
      break;
    case constants.SETTINGS.AUTOMATED_SHARING:
      _component = import("../../components/AutomatedShare");
      break;
    case constants.SETTINGS.USER_GROUPS:
      _component = import("../../components/UserGroupManagement");
      break;
    case constants.SETTINGS.WORKLIST_TAGS:
      _component = import("../../components/WorklistTagsSetting");
      break;
    case constants.SETTINGS.FORM_TEMPLATES:
      _component = import("../../components/FormSettings");
      break;
    case constants.SETTINGS.WORKSPACE_MANAGEMENT:
      _component = import("../../components/WorkspaceManagement");
      break;
    case constants.SETTINGS.SITE_MANAGEMENT:
      _component = import("../../components/WorkspaceManagement");
      break;
    case constants.SETTINGS.REPORT_TEMPLATE:
      _component = import("../../components/ReportTemplate");
      break;
    case constants.SETTINGS.GATEWAY:
      _component = import("../../components/GatewayIndicator");
      break;
    case constants.SETTINGS.MODALITY_CONNECT:
      _component = import("../../components/ConnectModality");
      break;
    case constants.SETTINGS.DISK_MANAGEMENT:
      _component = import("../../components/DiskManagement");
      break;
    case constants.SETTINGS.REMOTE_ACCESS:
      _component = import("../../components/RemoteAccess");
      break;
    case constants.SETTINGS.LICENSE_MANAGER:
      _component = import("../../components/LicenseManager");
      break;
    case constants.SETTINGS.SCAN_TO_CONNECT:
      _component = import("../../components/ScanToConnect");
      break;
    case constants.SETTINGS.AI:
      _component = import("../../components/AiChat/AiChatSettings");
      break;
    default:
      _component = null;
  }
  return dynamic(function () {
    return _component;
  }, {
    ssr: false,
    loading: function loading() {
      return /*#__PURE__*/React.createElement(Loader, {
        size: "medium",
        label: "".concat(t("loading_key"), "...")
      });
    }
  });
};
var SettingsPage = function SettingsPage(props) {
  var pageName = props.pageName,
    onChangeSetting = props.onChangeSetting;
  var router = useRouter();
  var currentPageName = pageName || get(router, ["query", "params", "0"], "");
  var DynamicComponent = useMemo(function () {
    return getComponent(currentPageName);
  }, [currentPageName]);
  var onChangeSettingPage = function onChangeSettingPage(_pageName, pageNo) {
    router.replace("/settings/".concat(_pageName).concat(pageNo ? "/" + pageNo : ""), undefined, {
      shallow: true
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("dark:bg-gray-900 sm:bg-gray-200 sm:dark:bg-gray-800 w-full flex flex-col h-full items-center justify-center overflow-x-hidden", {
      "pt-6": isWebView()
    })
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: "".concat(t("loading_key"), "...")
  }, /*#__PURE__*/React.createElement(DynamicComponent, {
    pageName: currentPageName,
    onChangeSetting: onChangeSetting || onChangeSettingPage
  })));
};
export default SettingsPage;
export function getStaticProps() {
  return _getStaticProps.apply(this, arguments);
}
function _getStaticProps() {
  _getStaticProps = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", {
            // Passed to the page component as props
            props: {
              hideMenu: true
            }
          });
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getStaticProps.apply(this, arguments);
}
export var getStaticPaths = function getStaticPaths() {
  return {
    paths: [],
    //indicates that no page needs be created at build time
    fallback: "blocking" //indicates the type of fallback
  };
};